// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3s-Ub","button_purple":"Button_button_purple__1yP97"};